export default "__VITE_ASSET__DpZ7ei94__"